import { Component, Input, OnInit } from '@angular/core';

import { BillAccountPaymentsScheduleRow, BundledPayments } from '@amfam/shared/models';

@Component({
  selector: 'ds-bill-account-payments-scheduled-bundle',
  templateUrl: './bill-account-payments-scheduled-bundle.component.html',
  styleUrls: ['./bill-account-payments-scheduled-bundle.component.scss'],
  standalone: false
})
export class BillAccountPaymentsScheduledBundleComponent implements OnInit {
  @Input() selectedScheduledPayment: BillAccountPaymentsScheduleRow;

  public bundledPayments: BundledPayments[] = [];

  constructor() {}

  ngOnInit() {
    this.bundledPayments = this.selectedScheduledPayment.bundledPayments;
  }
}
